import { ISupplierType } from 'common/dto/generated/SupplierDto';

export enum SupplierCustomColumnSort {
  fullname = 'fullname'
}

export type SupplierColumnSort = SupplierCustomColumnSort | keyof ISupplierType;
